export enum UserTicketsCollapsedSortColumnsEnum {
  START_DATE = 'startDate',
  EVENT_NAME = 'eventName'
}
